import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import PlaceHolderImage from "./placeholder-image.jpg";

const EmployeeProfileImage = (props) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const dragAndDropContainerStyles = { border: "1px solid black", width: "100%", color: "black", padding: 20 };

  useEffect(() => {
    props.fileUploadHandler(acceptedFiles[0]);
  }, [acceptedFiles]);
  return (
    <div style={dragAndDropContainerStyles} {...getRootProps({ className: "dropzone" })}>
      <input {...getInputProps()} />
      <Typography fontSize={18}>
        {acceptedFiles.length > 0 ? acceptedFiles[0].path : "You can Drag here or click here and upload the image file"}
      </Typography>
      <IconButton color="primary" aria-label="upload picture" component="span">
        <CloudUploadIcon fontSize="large" color="#f1f2f4" />
      </IconButton>
      {!props.offImage && (
        <Box
          component="img"
          sx={{
            width: 180,
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }}
          alt="The house from the offer."
          src={props.photo ? props.photo : PlaceHolderImage}
        />
      )}
    </div>
  );
};

export default EmployeeProfileImage;
